module.exports = __webpack_public_path__ + "static/media/heart_filledsvg.9c798213.svg";